import PropTypes from 'prop-types';
import React from 'react';
import { Persist } from 'formik-persist';
import { Formik } from 'formik';

export default function FormWrapper({
  initialValues,
  validationSchema,
  onSubmit,
  component,
  validateOnBlur,
  validateOnChange,
  makePersist,
  persistStorageName,
  ...additionalProps
}) {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      validateOnBlur={validateOnBlur}
      validateOnChange={validateOnChange}
      {...additionalProps}
    >
      {(props) => (
        <>
          {makePersist && <Persist name={persistStorageName} />}
          {component(props)}
        </>
      )}
    </Formik>
  );
}

FormWrapper.propTypes = {
  initialValues: PropTypes.object,
  validationSchema: PropTypes.object,
  persistStorageName: PropTypes.string,
  makePersist: PropTypes.bool,
  onSubmit: PropTypes.func,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool,
  additionalProps: PropTypes.object,
};
